import React, { Component } from 'react';

export default class Logo extends Component {
    render() {
        return <div style={{ backgroundImage: `url(${window.VULOG_CONFIG.LOGO_IMAGE})` }} className="logo__main"></div>;
    }
}
